import React, { useState } from 'react';
import { wordsToIpa } from '../../transcribe/wordsToIpa';
import { Say } from '../widgets/Say';
import { EnglishAccentType, accentLinks } from '../../ruleSets/accentRules';
import { accentColors } from './constants';
import { SayAccentPhones } from './SayAccent';
import { findLexicalSets, lexicalSets } from '../../rules/findLexicalSets';
import { replaceLexicalTokens } from '../../rules/replaceLexicalSets';

/**
 * UI for looking up the pronunciation of words in the US and UK dictionaries
 * and a selection of accents
 */
export function MultiLookup(props: {
  readonly accents: EnglishAccentType[]
}) {
  const [word, setWord] = useState('');
  const [toSay, setToSay] = useState('');
  const [withSets, setWithSets] = useState('');
  const [pronounceUS, setPronounceUS] = useState('');
  const [pronounceUK, setPronounceUK] = useState('');

  function onKey(s: string) {
    if (s === 'Enter') {
      lookup();
    }
  }

  function lookup() {
    setToSay(word);

    const tokenized = findLexicalSets(word);
    const lookup = lexicalSets.map(set => '(' + set.name + ')');
    const lexicalIpa = replaceLexicalTokens(tokenized, lookup);
    setWithSets(lexicalIpa);

    const [us] = wordsToIpa(word);
    setPronounceUS(us.length > 0 ? `/${us}/` : '?');
    const [uk] = wordsToIpa(word, 'en_UK');
    setPronounceUK(uk.length > 0 ? `/${uk}/` : '?');
  }

  return (<>
    <p>
      <input size={30} value={word} maxLength={60}
        onChange={(e) => setWord(e.target.value)} onKeyPress={(e) => onKey(e.key)} />
      &nbsp;&nbsp;
      <button onClick={() => lookup()} disabled={word.length === 0}>lookup</button>
    </p>

    <table>
      <tbody>
        <tr>
          <td>US dictionary</td>
          <td>{pronounceUS.length === 0 ? '' : pronounceUS === '?' ? <i>not present</i> : <Say accent='Dictionary US'>{pronounceUS}</Say>}</td>
        </tr>
        <tr>
          <td>UK dictionary</td>
          <td>{pronounceUK.length === 0 ? '' : pronounceUK === '?' ? <i>not present</i> : <Say accent='Dictionary UK' textColor={accentColors['English RP']}>{pronounceUK}</Say>}</td>
        </tr>
        <tr>
          <td>Lexical Sets</td>
          <td>{withSets}</td>
        </tr>
        {props.accents.map(a => {
          return (
            <tr key={a}>
              <td>{accentLinks[a] === '' ? a : <a href={accentLinks[a]}>{a}</a>}</td>
              <td><SayAccentPhones accent={a}>{toSay}</SayAccentPhones></td>
            </tr>
          )
        })}
      </tbody>
    </table>
  </>);
}
